import { Check } from "lucide-react";
import logo from "assets/images/bebrave.png";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function SignupEmailSentPage() {
  const { t } = useTranslation();
  const { state } = useLocation();
  const email = state?.email;
  return <div className="flex min-h-screen flex-col items-center justify-center bg-background">
    <div className="mb-4 p-4 sm:mt-[-252px]">
      <img src={logo} className="w-full h-full" alt="logo" />
    </div>
    <Check className="my-6 text-[#17C964]" size={40} />
    <div className="mx-auto flex w-11/12 flex-col items-center gap-1 text-center sm:max-w-2xl">
      <h3 className="my-6 text-3xl font-bold tracking-tight">{t('EMAIL_SENT')}</h3>
      <p className="text-xl text-foreground">
        {t('EMAIL_SENT_TO')}{" "}
        <span className="font-semibold text-primary underline">{email}</span>. {t('PLEASE_FOLLOW_LINK')}
      </p>
    </div>
  </div>;
}
